export default __webpack_public_path__ + "static/media/medicalalertdrive.b6862943.jpg";